import ApiService from "@/common/api.service";

export const createCustomWebhook = {
  async createCustomWebhook({ commit }, { payload, store_id }) {
    const response = await ApiService.post(`/stores/${store_id}/webhook/create`, {
      ...payload
    });
  }
};
